import React from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { Note } from "../../types/types";
import styles from "./Sidebar.module.css";

interface Props {
    notes?: Note[];
    onDeleteNote(note: Note): void;
}
export function Sidebar({ notes, onDeleteNote }: Props) {
    const { url } = useRouteMatch()
    return (
        <aside className={ styles.sidebar }>
            <ul className={ styles.notes }>
                <li><Link to={ `${url}/create` }>Create a note</Link></li>
                { (notes || []).map(note => (
                    <li key={ note.noteId }>
                        <Link to={`${url}/${note.noteId}`}>
                            {note.title || "Untitled"} - { new Date((note.createdDate ?? note.created) as number).toLocaleDateString() }
                        </Link>
                        <button onClick={ (e) => { e.stopPropagation(); onDeleteNote(note) }}>×</button>
                    </li>
                ))}
            </ul>
        </aside>
    )
}